import './styles/App.css';
import Header from './components/Header';
import Aside from './components/Aside';
import ColorBlindness from './components/ColorBlindness';
import ColorContrast from './components/ColorContrast';
import ColorPicker from './components/ColorPicker';
import SimulPage from './components/SimulPage';
import ImageSelector from './components/ImageSelector';
import ImageSimulPage from './components/ImageSimulPage';
import WcagContrastRatio from './components/WcagContrastRatio';
import ColorSuggestion from './components/ColorSuggestion';
import SavedPalette from './components/SavedPalette';
import { useEffect, useState } from 'react';
import {Route, Routes} from 'react-router-dom'

function App() {
  const [isOpen, setIsOpen] = useState(false)
  const [isActive, setIsActive] = useState("")
  const [simulatedColor, setSimulatedColor] = useState([])
  const [blindType, setBlindType] = useState("PROTANOPIA")
  const [color, setColor] = useState("#2b2d31")
  const [imageSrc, setImageSrc] = useState("")
  const [matrixId, setMatrixId] = useState("0")
  const [imgProp, setImgProp] = useState([])
  const [imgBlindType, setImgBlindType] = useState("PROTANOPIA")
  const [palette, setPalette] = useState([])
  const [suggest, setSuggest] = useState(false)
  const [main, setMain] = useState("#2b2d31")
  const [buttonState, setButtonState] = useState("Save")

  useEffect(() => {
    handleBurger(isOpen)
  }, [isOpen])

  const handleBurger = (isOpen) => {
    isOpen === true ? setIsActive("active") : setIsActive("")
  }

  return (
    <div className="App">
      <Header
        handleBurger={handleBurger}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
      <hr className='separator' />
      <div className='Content'>
        <Aside 
          isActive={isActive}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
        <Routes>
          <Route path='*' element={<ColorBlindness 
            setSimulatedColor={setSimulatedColor}
            blindType={blindType}
            setBlindType={setBlindType}
            color={color}
            setColor={setColor}
          />}/>
          <Route path='/color-picker' element={<ColorPicker/>}/>
          <Route path='/image-selector' element={<ImageSelector
            imageSrc={imageSrc}
            setImageSrc={setImageSrc}
            matrixId={matrixId}
            setMatrixId={setMatrixId}
            setImgProp={setImgProp}
            imgBlindType={imgBlindType}
            setImgBlindType={setImgBlindType}
          />}/>
          <Route path='/simulated-page' element={<SimulPage 
            simulatedColor={simulatedColor}
            color={color}
            blindType={blindType}
          />}/>
          <Route path='/simulated-image-page' element={<ImageSimulPage
            imageSrc={imageSrc}
            matrixId={matrixId}
            setMatrixId={setMatrixId}
            imgProp={imgProp}
            imgBlindType={imgBlindType}
          />}/>
          <Route path='/color-contrast' element={<ColorContrast/>}/>
          <Route path='/wcag-contrast-ratio' element={<WcagContrastRatio/>}/>
          <Route path='/color-palette' element={<ColorSuggestion
            palette={palette}
            setPalette={setPalette}
            suggest={suggest}
            setSuggest={setSuggest}
            main={main}
            setMain={setMain}
            buttonState={buttonState}
            setButtonState={setButtonState}
          />}/>
          <Route path='/color-palette/saved-palette' element={<SavedPalette
            setPalette={setPalette}
            setSuggest={setSuggest}
            setMain={setMain}
            setButtonState={setButtonState}
          />}/>
        </Routes>
      </div>
    </div>
  );
}

export default App;
